module.exports = __webpack_public_path__ + "img/ZXX-01.e25e8a35.png";